import yup from 'src/libraries/validator.library';

export const ChangeLogSchema = yup
  .object({
    ChangeLogDetail: yup
      .object({
        detailId: yup.number(),
        field: yup.string().defined(),
        newValue: yup.string().nullable(),
        oldValue: yup.string().nullable(),
        summaryId: yup.number(),
      })
      .nullable()
      .defined(),
    changeType: yup.string(),
    lastModifiedDate: yup.date(),
    modifiedByEmpNo: yup.string().nullable(),
    modifiedByName: yup.string().nullable(),
    requestId: yup.number(),
    summaryId: yup.number(),
    tableName: yup.string(),
  })
  .defined();

export const ChangeLogsSchema = yup
  .object({
    changelog: yup
      .object({
        count: yup.number(),
        rows: yup.array().of(ChangeLogSchema.clone()),
      })
      .defined(),
  })
  .defined();

export type IChangeLog = yup.InferType<typeof ChangeLogSchema>;
